import { createApi } from '@reduxjs/toolkit/query/react';

import {
  getBaseUrlObNextGen,
  getObNextGenApiUrlLists,
} from '../../../constants/obNextGenConstants';
import { axiosBaseQuery } from '../../../services/baseQuery';
import {
  type StartImportErrorResponse,
  type StartImportRequest,
  type StartImportSuccessResponse,
} from '../data-layer/startImportTypes';

const { START_IMPORT } = getObNextGenApiUrlLists();

export const startImportApi = createApi({
  reducerPath: 'startImportApi',
  baseQuery: axiosBaseQuery({
    baseUrl: getBaseUrlObNextGen(),
  }),
  endpoints: (builder) => ({
    startImport: builder.mutation<
      StartImportSuccessResponse,
      StartImportRequest
    >({
      query: (body) => ({
        url: START_IMPORT,
        method: 'POST',
        data: body,
      }),
      transformErrorResponse: (response: {
        status: number;
        data: StartImportErrorResponse;
      }) => response.data,
    }),
  }),
});

export const { useStartImportMutation } = startImportApi;
